import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { OMSPROFILE } from '../../../API';
import { logFrontendActivity } from '../../General/activityLogger';

export const profileslice = createSlice({
    name: 'profile',
    initialState: {
        profile: {},
        meta: [],
        loading: false,
        hasErrors: false,
        message: "",
        notification: { show: false, messageContent: "", messageType: "success" }
    },
    reducers: {
        getProfile: (state) => {
            return {
                ...state,
                loading: true
            }
        },
        getProfileSuccess: (state, action) => {
            return {
                ...state,
                profile: action && action.payload && action.payload.data && action.payload.data.data,
                meta: action && action.payload && action.payload.data && action.payload.data.meta,
                loading: false,
                hasErrors: false
            }
        },
        getProfileFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true
            }
        },
        putProfile: (state) => {
            return {
                ...state,
                loading: true
            }
        },
        putProfileSuccess: (state, action) => {
            return {
                ...state,
                profile: action && action.payload && action.payload.data && action.payload.data.data,
                message: action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message,
                loading: false,
                hasErrors: false                
            }
        },
        putProfileFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                message: action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message
            }
        },
        putProductSettings: (state) => {
            return {
                ...state,
                loading: true
            }
        },
        putProductSettingsSuccess: (state, action) => {
            return {
                ...state,
                profile: action && action.payload && action.payload.data && action.payload.data.data,
                message: action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message,
                loading: false,
                hasErrors: false,
                notification: { show: true, messageContent: (action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message === "Product settings Saved Successfully") ? ["Product settings Saved Successfully"] : [""], messageType: "success" }
            }
        },
        putProductSettingsFailure: (state, action) => {
            return {
                ...state,
                loading: false,
                hasErrors: true,
                message: action && action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message,
                notification: { show: true, messageContent: action.payload && action.payload.data && action.payload.data.data && action.payload.data.data.message ? [action.payload.data.data.message] : [""], messageType: "error" }

            }
        },
        resetProfileSettings: (state, action) => {
            return {
                ...state,
                    profile: action && action.payload && action.payload.data && action.payload.data.data,
                    notification: { show: false, messageContent: "", messageType: "success" }
            }
        }

    },
    // ─── LISTEN TO AUTH SLICE ACTIONS TO PREVENT SECOND GET REQUEST ───
    extraReducers: (builder) => {
        builder
            .addCase('postLogin/verifyAuthSuccess', (state, action) => {
                state.profile = action?.payload?.data?.data || {};
                state.meta = action?.payload?.data?.meta || [];
                state.loading = false;
                state.hasErrors = false;
            })
            .addCase('postLogin/postLoginSuccess', (state, action) => {
                state.profile = action?.payload?.data?.data || {};
                state.meta = action?.payload?.data?.meta || [];
                state.loading = false;
                state.hasErrors = false;
            });
    }
})
export const { getProfile, getProfileSuccess, getProfileFailure, putProfile,
    putProfileSuccess, putProfileFailure, putProductSettings,
    putProductSettingsSuccess, putProductSettingsFailure,resetProfileSettings } = profileslice.actions;


export const fetchProfile = (options = {}) => (dispatch, getState) => {
    const state = getState();
    const profile = state.profile;
    const auth = state.auth || state.postLogin; // 👈 Handles both naming variations safely

    // 1. If auth verification or profile fetch is active, skip redundant request
    if ((profile?.loading || auth?.loginLoading) && !options.force) {
        return;
    }

    // 2. If profile is ALREADY populated from auth verification, skip
    if (profile?.profile && Object.keys(profile.profile).length > 0 && !options.force) {
        return;
    }

    dispatch(getProfile());

    const config = options.force ? { params: { force: true } } : {};

    OMSPROFILE.get('/profile', config)
        .then(function (response) {
            dispatch(getProfileSuccess(response));
        })
        .catch(function (error) {
            dispatch(getProfileFailure());
        });
};
export const updateProfile = (userid,data) => dispatch => {
    dispatch(putProfile());
    const logRef = crypto.randomUUID();
    try {
        OMSPROFILE.patch('/profile/1', data, { 
            headers: { 
                'x-log-ref': logRef
                 } 
            })
            .then(function (response) {
                dispatch(putProfileSuccess(response));
                dispatch(getProfileSuccess(response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'PROFILE',
                    action: 'SUCCESS',
                    request_data: data,
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }else{
                        console.log('Activity log failed:', ref);
                    }
                });
            }).catch(function (error) {
                dispatch(putProfileFailure(error.response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'PROFILE',
                    action: 'FAILURE',
                    request_data: data,
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                }).then((ref) => {
                    if (ref) {
                        console.log('Activity log recorded with log_ref:', ref);
                    }
                });
            })
    }
    catch (error) {
        dispatch(putProfileFailure());
    }
}
// 2. Update updateProductSettings to pass { force: true }
export const updateProductSettings = (userid, data) => dispatch => {
    dispatch(putProductSettings());
    const logRef = crypto.randomUUID();
    try {
        OMSPROFILE.post('/product-settings', data, {
            headers: { 'x-log-ref': logRef }
        })
            .then(function (response) {
                dispatch(putProductSettingsSuccess(response));
                
                // 👈 Re-fetch profile with force: true
                dispatch(fetchProfile({ force: true }));

                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'PRODUCT_SETTINGS',
                    action: 'SUCCESS',
                    request_data: data,
                    response_data: response.data,
                    log_ref: logRef,
                    userid: userid
                });
            }).catch(function (error) {
                dispatch(putProductSettingsFailure(error.response));
                logFrontendActivity({
                    group: 'SETTINGS',
                    subgroup: 'PRODUCT_SETTINGS',
                    action: 'FAILURE',
                    request_data: data,
                    response_data: error.response?.data || {},
                    log_ref: logRef,
                    userid: userid
                });
            });
    } catch (error) {
        dispatch(putProductSettingsFailure(error.response));
    }
};
// 3. Update resetProfile to pass { force: true }
export const resetProfile = () => {
    return (dispatch) => {
        dispatch(resetProfileSettings());
        
        // 👈 Re-fetch profile with force: true
        dispatch(fetchProfile({ force: true }));
    };
};
export default profileslice.reducer;
